module.exports = __webpack_public_path__ + "img/Customer.0cc9980b.png";